import { CustomTabs } from '@ncr-retail/base-retail-components';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { createProductDisplayMenu } from 'src/common/helpers/create-product-display-menu';
import { CashierPreferences } from 'src/common/interfaces/dtos/CashierPreferences';
import { IPluMenuState } from 'src/common/interfaces/states/IPluMenuState';
import { AppState } from 'src/common/redux/configure-store';
import { ReturnsType } from 'src/transaction-search/interfaces/get-effective-return-policy-response';
import PluMenuItem from '../plu-menu-item';
import { styles } from './plu-menu-styles';

interface PLUMenuProps {
  bottomMenuButtons?: boolean;
}

const PLUMenu = ({ bottomMenuButtons }: PLUMenuProps): JSX.Element | null => {
  const pluMenuState = useSelector<AppState, IPluMenuState>(state => state.pluMenu);
  const disabled = useSelector<AppState, boolean>(
    state =>
      state.baseView.pluMenuDisabled ||
      state.posMode.returnMode.returnType === ReturnsType.TransactionBasedReturn,
  );
  const trainingModeActive = useSelector<AppState, boolean>(state => state.posMode.trainingMode);
  const cashierPreferences = useSelector<AppState, CashierPreferences>(
    state => state.cashierPreferences,
  );
  const { leftHanded } = cashierPreferences;
  const classes = styles({ leftHanded });
  const { t } = useTranslation();

  useEffect((): void => {
    createProductDisplayMenu(pluMenuState.consumableGroup);
  }, [pluMenuState.consumableGroup]);

  const menuItems = pluMenuState.productDisplayMenus;

  if (!menuItems.length) {
    return null;
  }

  return bottomMenuButtons ? (
    <PluMenuItem
      label={t('PLU_Menu')}
      item={menuItems[0]}
      trainingModeActive={trainingModeActive}
      disabled={disabled}
      index={0}
    />
  ) : (
    <CustomTabs
      data-testid='plu-group-custom-tabs'
      value={false}
      className={classes.customTabs}
      classes={{
        scrollButtons: classes.scrollButton,
      }}
      TabIndicatorProps={{ style: { display: 'none' } }}
    >
      {menuItems.map(
        (item, index): JSX.Element => {
          return (
            <PluMenuItem
              key={item.Name ?? ''}
              item={item}
              trainingModeActive={trainingModeActive}
              disabled={disabled}
              index={index}
            />
          );
        },
      )}
    </CustomTabs>
  );
};

export default PLUMenu;
